import { useTranslation } from 'react-i18next'

import { GetReportResponse } from '@/hooks'

import { UpdateReportButton } from '@/components/molecules/UpdateReportButton/UpdateReportButton'
import { ReportHeader } from '../ReportHeader/ReportHeader'
import { SaveAsNewReportButton } from './SaveAsNewReportButton'
import { ReportEditableTitleContainer } from '../ReportEditableTitleContainer/ReportEditableTitleContainer'

export type ReportEditHeaderProps = {
    initialReportName: string
    report: GetReportResponse
    onChangeName?: (reportName: string) => void
    onSaveAsNewReportSuccess?: () => void
    onUpdateReportSuccess?: (updatedReport: GetReportResponse) => void
    onUpdatePendingChange?: (isPending: boolean) => void
}

export const ReportEditHeader: React.FC<ReportEditHeaderProps> = (props) => {
    const {
        initialReportName,
        report,
        onChangeName,
        onSaveAsNewReportSuccess,
        onUpdateReportSuccess,
        onUpdatePendingChange,
    } = props

    const { t } = useTranslation('translations')

    return (
        <ReportHeader
            backToPath={`/reporting/${report.customReportId}`}
            backToLabel={t('reporting.update_report.exit_customization')}
            title={report.name}
            renderTitle={() => (
                <ReportEditableTitleContainer
                    initialValue={initialReportName}
                    value={report.name}
                    onChange={onChangeName}
                />
            )}
        >
            <div className="flex gap-4">
                <SaveAsNewReportButton
                    label={t(
                        'reporting.save_report.save_as_new_report_modal.title'
                    )}
                    report={report}
                    onSuccess={onSaveAsNewReportSuccess}
                    onPendingSave={onUpdatePendingChange}
                />
                <UpdateReportButton
                    report={report}
                    onSuccess={onUpdateReportSuccess}
                    onPendingChange={onUpdatePendingChange}
                />
            </div>
        </ReportHeader>
    )
}
